import { getKpPageItemValues } from '@deltek/specification-client/core/Utilities/localstorageUtils'
import {
    ElementTreeView,
    FamilyNumberFormat,
    UnitsOfMeasure,
} from 'models/projectSettings'
export const getLocalStorageValue = (
    field: string,
    currentUserId: string,
    emptyValue: boolean | string | string[],
    localStorageKey: string
) => {
    const workspaceProgressTableStore = getKpPageItemValues({
        currentUserId,
        pageKey: localStorageKey,
    })

    return workspaceProgressTableStore?.[field] ?? emptyValue
}

export const getFamilyNumberDecimalValues = (familyNumber: string) => {
    const familyNumberSplit = familyNumber.split('.')
    if (familyNumberSplit.length > 1) {
        return `.${familyNumberSplit[1]}`
    }

    return ''
}

export const getFormattedFamilyNumber = (
    familyNumber: string,
    famNumberFormat: FamilyNumberFormat
) => {
    var formattedFamNumber = ''
    const famNumberDecimal = getFamilyNumberDecimalValues(familyNumber)
    switch (famNumberFormat) {
        case FamilyNumberFormat.XX_XXXX.replace(/ /g, '_'):
            formattedFamNumber = `${familyNumber?.[0]}${familyNumber?.[1]} ${familyNumber?.[2]}${familyNumber?.[3]}${familyNumber?.[4]}${familyNumber?.[5]}${famNumberDecimal}`
            break
        case FamilyNumberFormat.XX_XX_XX.replace(/ /g, '_'):
            formattedFamNumber = `${familyNumber?.[0]}${familyNumber?.[1]} ${familyNumber?.[2]}${familyNumber?.[3]} ${familyNumber?.[4]}${familyNumber?.[5]}${famNumberDecimal}`
            break
        default:
            formattedFamNumber = `${familyNumber?.[0]}${familyNumber?.[1]}${familyNumber?.[2]}${familyNumber?.[3]}${familyNumber?.[4]}${familyNumber?.[5]}${famNumberDecimal}`
            break
    }

    return formattedFamNumber
}

export const defaultProjSettings = {
    collectData: true,
    familyNumberFormat: FamilyNumberFormat.XXXXXX,
    unitOfMeasure: 'IMPERIAL' as UnitsOfMeasure,
    elementTreeView: 'DIVISIONS' as ElementTreeView,
}
